export default {
  name: "compXinjiangCategory",
  data() {
    return {
      typeIndex: 0,
      typeclick: false
    };
  },
  created() {
    if (!this.$attrs.showtypeall) {
      this.typeIndex = 1;
    }
  },
  watch: {
    "$attrs.showtypeall": {
      handler(val) {
        if (this.typeclick) return;
        this.typeIndex = val ? 0 : 1;
      },
      immediate: true
    }
  },
  methods: {
    typeClick(item, index) {
      this.typeclick = true;
      this.typeIndex = index;
      this.$emit("typeselect", {
        index,
        item
      });
    }
  }
};